import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class PriceService {

    private API_URL = environment.API_URL;
    constructor(private http: HttpClient) { }

    public getHhpDropDownDetails(params, url): Observable<any> {
        // return this.http.post(`${this.API_URL + url}`, params);
        const data = {
            "financial_reporting_region": [
                "Region",
            ],
            "business_view": [
                "Business View"
            ],
            "sub_business_view": [
                "Sub Business View"
            ],
            "lob_segment_2": [
                "Log Segment"
            ],
            "type": [
                "Type"
            ],
            "revised_product_family_standard": [
                "Engine Models"
            ],
            "channel_new": [
                "Channels"
            ],
            "revised_customer_name": [
                "Customer Name"
            ],
            "wave_initiative": [
                "Wave Initiative"
            ],
            "classification": [
                "Classifications"
            ],
            "product_flag": [
                "Product Flag"
            ],

        }
        return of(data);
    }

    public getTotalPriceImpact(params, url): Observable<any> {
        // return this.http.post(`${this.API_URL + url}`, params);
        const data = {
            "pricerealizedby_pricespec_prices": 1812921.65,
            "comparable_customer_specs": 661995,
            "unmapped": 1102520,
            "total_price_impact": 4000000,
        }
        return of(data);
    }

    public getTotalVolumeImpact(params, url): Observable<any> {
        // return this.http.post(`${this.API_URL + url}`, params);
        const data = {
            "pricerealizedby_pricespec_prices": 138204627,
            "comparable_customer_specs": 45610594,
            "unmapped": 9840982,
            "sales_2023": 193000000,
        }
        return of(data);
    }

    public getPriceBridgeData(params, url): Observable<any> {
        // return this.http.post(`${this.API_URL + url}`, params);
        const data = {
            "base_sales": 148244280.0,
            "comparable_base": 189718765.37,
            "total_price_impact": 3577437.63,
            "comparable_current": 193326832.0,
            "financial_adjustments": 3962861.0,
            "curent_sales": 197289693.0,
        }
        return of(data);
    }

    public getTotalDimension(params, url): Observable<any> {
        // return this.http.post(`${this.API_URL + url}`, params);
        const data = {
            "data": {
                "price_spec": {
                    "DENNIS EAGLE": 85707.91,
                    "NEW FLYER INDUSTRIES LTD": 447181.1,
                    "IC BUS OF OKLAHOMA LLC": 11646.259999999995,
                    "CMI-U.K": 47652.170000000006,
                    "NAVISTAR": 25915.200000000186,
                    "CMI-NETHERLANDS": 7923.199999999999,
                    "TEMSA ULASIM ARACLARI SANAYI": -111866.0,
                    "ROSENBAUER MOTORS LLC": 29478.0,
                    "CNHTC CO.,LTD": 31900.09,
                    "CMI-U.S": 64882.110000000015,
                    "HONGKONG ZHANGZHAN": 27737.620000000003,
                    "ANADOLU ISUZU OTOMOTIV SANAYI": 6980.0,
                    "PIERCE MANUFACTURING": 218197.69,
                    "VE COMMERCIAL VEHICLES LIMITED": -5717.110000000001,
                    "DAF CAMINHOES BRASIL INDUSTRIA": -35813.88,
                    "OTTAWA TRUCK CORP": 378271.56,
                    "CHRYSLER": 2343408.21,
                    "NINGBO KANGZHAN INTERNATIONAL": 4999.56,
                    "BLUE BIRD": 42223.41,
                    "OSHKOSH DEFENSE": 205774.63,
                    "MAN LATIN AMERICA IND COM LTDA": -472851.23,
                    "TEREX": 188707.15,
                    "CMI-CANADA": 41991.67,
                    "KENWORTH": 3997277.689999999,
                    "HINO MOTORS": -150833.43,
                    "TATA": -337428.0,
                    "POWERTEC": 23178.77,
                    "DAIMLER": 7162981.999999998,
                    "ANHUI JIANGKANG": -51246.37,
                    "CMI-HONG KONG": 12183.619999999999,
                    "CMI-SOUTH AFRICA": 1848.0,
                    "THOMAS BUILT BUS": 24802.450000000004,
                    "CHINA FAW GROUP IMPORT AND": -17062.52,
                    "VOLVO": 9459.479999999996,
                    "ISUZU": 201585.0,
                    "HERC RENTALS - 8540-ESC - EDMO": 310084.2100000001,
                    "MOTOR COACH INDUSTRIES, INC": 206940.56,
                    "CAPACITY OF TEXAS": 49308.0,
                    "VOLARE VEICULOS LTDA": 26514.33,
                    "BMC": 80620.23999999999,
                    "BAIC HEAVY TRUCK CO., LTD.": 6130.8499999999985,
                    "MACK": 1629238.21,
                    "AGRALE S A": 27767.17,
                    "NOVA BUS": 491479.55000000005,
                    "OTOKAR": 99028.43000000002,
                    "CRANE CARRIER COMPANY": 390868.7,
                    "BEIJING FOTON": -663.3000000000029,
                    "AUTOCAR LLC": 499996.91,
                    "GILLIG CORPORATION": 237250.75,
                    "CMI-CHINA": -160785.76,
                    "LINK-BELT MFG": 1025.67,
                    "SCANIA CV AB": 43567.28,
                    "CMI-MEXICO": 106970.23999999999,
                    "SPARTAN FIRE, LLC.": 124911.11000000002,
                    "PETERBILT": 3629512.14,
                    "CMI-ARGENTINA": 9677.22,
                    "XIAMEN FENGTAI BUS & COACH": -212.87,
                    "GROVE": 1170.119999999999
                }
            },
            "total": 2.2271475769999996E7
        }
        return of(data);
    }

    public priceTable(params, url): Observable<any> {
        // return this.http.post(`${this.API_URL + '/hhp/price/drilldown' + url}`, params);
        const data = [
            {
                "id": "d9bd0fe7-2352-4931-a00f-fe8d3317a860",
                "hierarchy": "External",
                "base": 4.5020213825709665E8,
                "attr": -4251315.320719999,
                "pure": 4.057760711823236E7,
                "mix": -1.0828688355898721E7,
                "discPure": -1.7298636364203837E7,
                "discMix": 6800356.471575977,
                "totalPrice": 1.9250638869705804E7,
                "volume": -5.979276796536677E7,
                "discVolume": 1.138376553681483E7,
                "totalVolume": -4.840900242855199E7,
                "productMix": 9.483184577916664E7,
                "customerMix": 8366098.83689,
                "forex": -4934398.347300798,
                "adjustment": -3723204.824424197,
                "acquisition": 386046.39236,
                "current": 5.117188472142222E8,
                "comparable_base": 4.459508229363766E8,
                "comparable_current": 5.113328008218622E8,
                "others": 0.0
            },
            {
                "id": "79b7e29a-92d6-4610-bb98-9bd19398fc2a",
                "hierarchy": "Internal",
                "base": 2.0930873113624004E8,
                "attr": -2972001.0432599997,
                "pure": 1.5232071492945129E7,
                "mix": 3199437.7676600255,
                "discPure": -1494255.04887963,
                "discMix": -950340.2892618905,
                "totalPrice": 1.5986913922463639E7,
                "volume": 3.1708427623047747E7,
                "discVolume": -2053734.32255835,
                "totalVolume": 2.96546933004894E7,
                "productMix": 6.0469434661641E7,
                "customerMix": -2.135063991653999E7,
                "forex": 23766.659310964573,
                "adjustment": -1.0721877568741003E7,
                "acquisition": 1693748.5780000002,
                "current": 2.82092769729604E8,
                "comparable_base": 2.0633673009298003E8,
                "comparable_current": 2.80399021151604E8,
                "others": 0.0
            },
            {
                "id": "71d41e23-7ab3-4df9-90c1-a32f7d0caf5d",
                "hierarchy": "Total",
                "base": 6.595108693933367E8,
                "attr": -7223316.363979999,
                "pure": 5.580967861117749E7,
                "mix": -7629250.588238696,
                "discPure": -1.8792891413083468E7,
                "discMix": 5850016.182314087,
                "totalPrice": 3.5237552792169444E7,
                "volume": -2.8084340342319027E7,
                "discVolume": 9330031.21425648,
                "totalVolume": -1.8754309128062587E7,
                "productMix": 1.5530128044080764E8,
                "customerMix": -1.2984541079649989E7,
                "forex": -4910631.687989833,
                "adjustment": -1.4445082393165201E7,
                "acquisition": 2079794.9703600002,
                "current": 7.938116169438262E8,
                "comparable_base": 6.522875530293566E8,
                "comparable_current": 7.917318219734662E8,
                "others": 0.0
            }
        ]
        return of(data);
    }

    public getClassificationTable(params, url): Observable<any> {
        // return this.http.post(`${this.API_URL + '/hhp/price/drilldown/' + url}`, params);
        const data = [
            {
                "id": "80e12352-4a2d-4da8-ba49-827fb1b0891b",
                "hierarchy": "DEFENSE",
                "base": 2.9408307496314306E7,
                "attr": -644334.97,
                "pure": 5095111.398113688,
                "mix": -2167522.458966903,
                "discPure": -1716108.1081081082,
                "discMix": 913077.0522074869,
                "totalPrice": 2124557.8832461643,
                "volume": -1.1262706569260586E7,
                "discVolume": -1450968.944099379,
                "totalVolume": -1.2713675513359966E7,
                "productMix": 1.774546433148E7,
                "customerMix": 8121580.0,
                "forex": -214123.78407619894,
                "adjustment": 88242.5309036999,
                "acquisition": 0.0,
                "current": 4.391601797450801E7,
                "comparable_base": 2.8763972526314303E7,
                "comparable_current": 4.391601797450801E7,
                "others": 0.0
            },
            {
                "id": "13453ee0-c413-4e57-a728-14e21dee5fda",
                "hierarchy": "MARINE",
                "base": 4.7179651388218105E7,
                "attr": -444005.90217,
                "pure": 1786180.997184121,
                "mix": 858991.0516012559,
                "discPure": -878365.9582310992,
                "discMix": -1136864.2540659935,
                "totalPrice": 629941.8364882851,
                "volume": 7722794.895959957,
                "discVolume": -1605287.5953644128,
                "totalVolume": 6117507.300595541,
                "productMix": 1.1452517195091007E7,
                "customerMix": 3224939.439019998,
                "forex": -623251.1711338243,
                "adjustment": -1073533.9805242994,
                "acquisition": 0.0,
                "current": 6.64637661055848E7,
                "comparable_base": 4.67356454860481E7,
                "comparable_current": 6.64637661055848E7,
                "others": 0.0
            },
            {
                "id": "152538b3-bb1d-4853-83a9-a17cbf86d3ce",
                "hierarchy": "MINING",
                "base": 2.743339628553761E8,
                "attr": -841746.2158,
                "pure": 2.052922757711475E7,
                "mix": -2566246.1856895895,
                "discPure": -6335449.0963261705,
                "discMix": 1086206.3275389972,
                "totalPrice": 1.2713738622637983E7,
                "volume": -8515054.568467172,
                "discVolume": 1258207.940635646,
                "totalVolume": -7256846.627831522,
                "productMix": 4.56031799564756E7,
                "customerMix": -2611775.838949999,
                "forex": -2813517.883913469,
                "adjustment": 6251486.279186005,
                "acquisition": 135910.02516,
                "current": 3.2551439117234045E8,
                "comparable_base": 2.734922166395761E8,
                "comparable_current": 3.253784811471805E8,
                "others": 0.0
            },
            {
                "id": "df48d527-59ed-4b47-a90f-d8fa51f87b87",
                "hierarchy": "OIL & GAS",
                "base": 5.960353623832949E7,
                "attr": -789775.3727500001,
                "pure": 1.1188732811322711E7,
                "mix": -7647301.48514651,
                "discPure": -8368713.201538457,
                "discMix": 5937937.345895485,
                "totalPrice": 1110655.4705332292,
                "volume": -5.021656808766352E7,
                "discVolume": 1.3181814135642974E7,
                "totalVolume": -3.703475395202054E7,
                "productMix": 5848126.73917,
                "customerMix": 854961.6768899999,
                "forex": -527195.945072671,
                "adjustment": -1019639.867941301,
                "acquisition": 250136.3672,
                "current": 2.8296051354338203E7,
                "comparable_base": 5.881376086557949E7,
                "comparable_current": 2.80459149871382E7,
                "others": 0.0
            },
            {
                "id": "dbbaf512-8f03-4d12-94ea-7fc008e7e780",
                "hierarchy": "RAIL",
                "base": 3.967668027885889E7,
                "attr": -1531452.8599999999,
                "pure": 1978354.334497102,
                "mix": 693390.7223030253,
                "discPure": 0.0,
                "discMix": 0.0,
                "totalPrice": 2671745.056800127,
                "volume": 2478766.364064508,
                "discVolume": 0.0,
                "totalVolume": 2478766.364064508,
                "productMix": 1.418255755695E7,
                "customerMix": -1223606.4400699995,
                "forex": -756309.5631046342,
                "adjustment": -7969759.786048302,
                "acquisition": 0.0,
                "current": 4.7528620607450604E7,
                "comparable_base": 3.81452274188589E7,
                "comparable_current": 4.7528620607450604E7,
                "others": 0.0
            },
            {
                "id": "829715e4-8660-45d2-b649-42f39e64b4d6",
                "hierarchy": "Total",
                "base": 4.502021382570969E8,
                "attr": -4251315.32072,
                "pure": 4.057760711823238E7,
                "mix": -1.0828688355898721E7,
                "discPure": -1.7298636364203833E7,
                "discMix": 6800356.471575975,
                "totalPrice": 1.925063886970579E7,
                "volume": -5.979276796536681E7,
                "discVolume": 1.1383765536814827E7,
                "totalVolume": -4.840900242855198E7,
                "productMix": 9.483184577916661E7,
                "customerMix": 8366098.836890001,
                "forex": -4934398.347300798,
                "adjustment": -3723204.824424199,
                "acquisition": 386046.39236,
                "current": 5.1171884721422213E8,
                "comparable_base": 4.4595082293637687E8,
                "comparable_current": 5.1133280082186216E8,
                "others": 0.0
            }
        ]
        return of(data);
    }

    public getPricePercentValues(params): Observable<any> {
        // return this.http.post(`${this.API_URL + '/hhp/price/totalpriceimpact/percentage/'}`, params);
        const data = {
            "total_price_impact_per": 80,
            "comparable_customer_specs_per": 10,
            "unmapped_per": 10,
            "pricerealizedby_pricespec_prices_per": 10
        }
        return of(data);
    }

    public getPricePercentValuesAlongRowValues(params: any, url: any): Observable<any> {
        // return this.http.post(`${this.API_URL + '/hhp/price/totalpriceimpact/percentage/' + url}`, params);
        const data = {
            "total_price_impact_per": 80,
            "comparable_customer_specs_per": 10,
            "unmapped_per": 10,
            "pricerealizedby_pricespec_prices_per": 10
        }
        return of(data);
    }

}